import * as ko from "knockout";
import {ICompanyLogin} from "../index";
import PromiseRequest from "../req/PromiseRequest";
import {_} from 'lodash';
import {storeObservable} from "../util/sessionstore";

export class CompanyLogin {

    private req_getcompanylogin: PromiseRequest = new PromiseRequest("getcompanylogin");

    collection: KnockoutObservableArray<ICompanyLogin> = ko.observableArray<ICompanyLogin>([]);
    selected: KnockoutObservable<ICompanyLogin | null> = storeObservable("selected.company.login", null);

    request() {
        return this.req_getcompanylogin
            .request()
            .then((organizations: ICompanyLogin[]) => {
                this.collection(organizations);
                return organizations
            });
    }

    setCompanyById(orgnr: ICompanyLogin['orgnr'], index: ICompanyLogin['vanityindex'] = 0) {
        const org = this.getCompanyById(orgnr, index)
        this.selected(org ?? null);
    }

    getCompanyById(orgnr: ICompanyLogin['orgnr'], index?: ICompanyLogin['vanityindex']) {
        return this.collection().find(o => {
            const is_orgnr = o.orgnr == orgnr
            const is_index =
                index === undefined || index === null ? true : o.vanityindex == index
            return is_orgnr && is_index
        });
    }

    /**
     * Hash `#/formlogin/{token}/{vanity}` — token matches {@link ICompanyLogin.orgnr} (eksakt eller ukasus),
     * eller valgfritt felt `organizationid` fra API om det finnes.
     */
    resolveCompanyForRoute(orgToken: string | number | undefined | null, vanity: number = 0): ICompanyLogin | undefined {
        if (orgToken === undefined || orgToken === null || orgToken === "") {
            return undefined;
        }
        const raw = String(orgToken).trim();
        if (!raw) {
            return undefined;
        }
        const lower = raw.toLowerCase();
        const matchIndex = (o: ICompanyLogin, idx: number | undefined): boolean =>
            idx === undefined || idx === null ? true : o.vanityindex == idx;

        const pick = (idx: number | undefined) =>
            this.collection().find(o => {
                if (!matchIndex(o, idx)) {
                    return false;
                }
                if (String(o.orgnr).trim().toLowerCase() === lower || String(o.orgnr) === raw) {
                    return true;
                }
                const oid = (o as unknown as {organizationid?: string | number}).organizationid;
                return oid != null && String(oid).trim() === raw;
            });

        return pick(vanity) ?? pick(0) ?? pick(undefined);
    }

    sorted = ko.pureComputed((): ICompanyLogin[] => _.sortBy(this.collection(), (o: ICompanyLogin) => o.name.toLowerCase()));

}
